// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"3016":"8abd0054","3359":"ba615f2f","3912":"ba615f2f","4522":"8abd0054","6572":"ba615f2f","7399":"95572145","7779":"8abd0054","9053":"8abd0054","9647":"ba615f2f"}[chunkId] + ".chunk.css";
};